import colors from './variables.scss';

const styles = {
  ...colors,
};

export default styles;
